import { c as _c } from "react/compiler-runtime";
import { User } from 'lucide-react';
import type React from 'react';
interface AvatarPlaceholderProperties {
  className?: string;
}
export const AvatarPlaceholder: React.FC<{
  className?: string;
}> = t0 => {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "h-full w-full" : t1;
  const t2 = `${className} relative flex items-center justify-center overflow-hidden rounded-full bg-green-200 font-medium text-white`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <User className="h-6 w-6" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
};